export type CADPosition = [number, number, number];

declare const displayedCADPositionBrand: unique symbol;
declare const cadCenterOffsetBrand: unique symbol;

export type DisplayedCADPosition = CADPosition & {
  readonly [displayedCADPositionBrand]: 'displayed-cad-position';
};

export type CADCenterOffset = CADPosition & {
  readonly [cadCenterOffsetBrand]: 'cad-center-offset';
};

export const createDisplayedCADPosition = (
  x: number,
  y: number,
  z: number,
): DisplayedCADPosition => [x, y, z] as DisplayedCADPosition;

export const createCADCenterOffset = (
  x: number,
  y: number,
  z: number,
): CADCenterOffset => [x, y, z] as CADCenterOffset;

/**
 * CADModelViewer centers the rendered GLB for easier camera control.
 * Viewer raycast intersections use that centered world coordinate, while
 * DRBFM anchors are stored in the original CAD coordinate system.
 */
export const restoreOriginalCADPosition = (
  displayedPosition: DisplayedCADPosition,
  centerOffset: CADCenterOffset,
): CADPosition => [
  displayedPosition[0] - centerOffset[0],
  displayedPosition[1] - centerOffset[1],
  displayedPosition[2] - centerOffset[2],
];

export interface PointerCoordinates {
  x: number;
  y: number;
}

export const isPointerSelectionClick = (
  pointerDown: PointerCoordinates,
  pointerUp: PointerCoordinates,
  maximumMovement = 5,
): boolean => Math.hypot(
  pointerUp.x - pointerDown.x,
  pointerUp.y - pointerDown.y,
) <= maximumMovement;

export const formatCADPosition = (
  position: CADPosition,
  fractionDigits = 2,
): string => position.map((value) => value.toFixed(fractionDigits)).join(', ');
